import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import QRCodeProps from './QRCodeProps'

import Border from './Border'

export default {
    props: QRCodeProps,
    emits: {
        'kendowidgetready': null
    },
    mixins: [
        KendoBaseComponent,
        Border
    ],
    mounted() {
        kendo.jQuery(this.$el).kendoQRCode(this.widgetOptions)

        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoQRCode()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-barcodes-vue-wrapper/src/KendoQRCode/KendoQRCodeMixin.js